const ExamineComponent = () => import('@/views/examine/ExamineView')

export default [
    {
        path:'/ExamineIndex',
        name:'ExamineIndex',
        component:ExamineComponent
    }
]